import React, { useEffect, useState } from 'react';
import { I18n } from 'react-redux-i18n';
import CheckBox from '@ui/CheckBox';
import { courseApi } from '@api/course';
import { laguageOptions } from '../gui/admin/stats/LessonsStats/CreateLessonModal/constants';

interface TeacherParamsFormProps {
  teacherParams: any;
  onChildAgeChange: (childAge: { from: string; to: string }) => void;
  onCanTeachCoursesChange: (canTeachCoursesIds: string[]) => void;
  onCanTeachLanguagesChange: (canTeachLanguages: string[]) => void;
}

const TeacherParamsForm: React.FC<TeacherParamsFormProps> = ({
  teacherParams,
  onChildAgeChange,
  onCanTeachCoursesChange,
  onCanTeachLanguagesChange,
}) => {
  const [allCourses, setAllCourses] = useState<any[]>([]);
  const [ageFrom, setAgeFrom] = useState<string>(teacherParams.childAge.from);
  const [ageTo, setAgeTo] = useState<string>(teacherParams.childAge.to);

  useEffect(() => {
    courseApi.getAllCourses().then(setAllCourses);
  }, []);

  useEffect(() => {
    setAgeFrom(teacherParams.childAge.from);
    setAgeTo(teacherParams.childAge.to);
  }, [teacherParams]);

  const onChangeAge = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'from') setAgeFrom(value);
    if (name === 'to') setAgeTo(value);
  };

  const onSaveAge = () => {
    onChildAgeChange({ from: ageFrom, to: ageTo });
  };

  const onToggleCourse = (courseId: string) => {
    const newCanTeachCourses = teacherParams.canTeachCoursesIds.includes(
      courseId
    )
      ? teacherParams.canTeachCoursesIds.filter(id => id !== courseId)
      : [...teacherParams.canTeachCoursesIds, courseId];

    onCanTeachCoursesChange(newCanTeachCourses);
  };

  const onToggleLanguage = (lang: string) => {
    const newCanTeachLanguages = teacherParams.canTeachLanguages.includes(lang)
      ? teacherParams.canTeachLanguages.filter(id => id !== lang)
      : [...teacherParams.canTeachLanguages, lang];

    onCanTeachLanguagesChange(newCanTeachLanguages);
  };

  if (!teacherParams) return null;
  return (
    <div>
      <div
        style={{
          display: 'flex',
          padding: '10px 0',
          gap: '10px',
          alignItems: 'center',
        }}
      >
        {I18n.t('admin.workingHours.ageFrom')}
        <input name="from" value={ageFrom} onChange={onChangeAge} />

        {I18n.t('admin.workingHours.ageTo')}
        <input name="to" value={ageTo} onChange={onChangeAge} />
        <button type="button" onClick={onSaveAge}>
          {I18n.t('main.buttons.save')}
        </button>
      </div>

      <p>
        <b>{I18n.t('admin.workingHours.courses')}</b>
      </p>
      {allCourses.map(course => (
        <CheckBox
          key={course._id}
          checked={teacherParams.canTeachCoursesIds.includes(course._id)}
          onChange={() => onToggleCourse(course._id)}
        >
          {course.name}
        </CheckBox>
      ))}

      <p style={{ paddingTop: '16px' }}>
        <b>{I18n.t('admin.workingHours.languages')}</b>
      </p>
      {laguageOptions.map(lang => (
        <CheckBox
          key={lang.value}
          checked={teacherParams.canTeachLanguages.includes(lang.value)}
          onChange={() => onToggleLanguage(lang.value)}
        >
          {lang.label}
        </CheckBox>
      ))}
    </div>
  );
};

export default TeacherParamsForm;
